/* The backend's own failure message (WS.java answers an unexpected error with exactly this). */
export const SOMETHING_WENT_WRONG = "Oops, something went wrong.";

/**
 * What to show for a request that failed: the backend's own text, as every other screen shows it.
 * A request that never got an answer (offline, a timeout) has no text, and says the backend's
 * generic message rather than the browser's "Network Error" or "Request failed with status code
 * 500". Takes the axios error, a response whose body said nok, or the text a hook already made of
 * one (it throws that string on).
 */
export const apiErrorText = (failure) =>
    (typeof failure === "string" && failure) ||
    failure?.response?.data?.text ||
    failure?.data?.text ||
    SOMETHING_WENT_WRONG;
